/* nc-pdp v1.6 (2026-11-04) — PDP buy section controller.
   v1.6: course cards + one-off/subscribe rows replace the bundle boxes, panel and toggle. Tiers carry "bottles"
   (per-bottle price, days, delivery interval, variant auto-binding), so the cards can be ordered 3-2-1.
   Savings are computed from the bound prices: one-off vs the 1-bottle tier, subscription vs one-off.
   Unchanged from v1.5: gallery, sticky column, accordions, label dialog, sticky bar + plan sheet, the cart add
   (nc-buy v3.10 drawer path: POST /cart/add.js, swap #CartDrawer, open()), rescue and the dispatch panel.
   Per instance, no globals except window.ncPdp (diagnostics). Timers torn down on section unload. */
(function () {
  'use strict';

  var DW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function toCents(str) {
    var m = /(\d[\d,]*(?:\.\d{1,2})?)/.exec(String(str || ''));
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
  }
  var PRICE_RE = /^(.*\D)(\d+)\.(\d{2})(.*)$/;
  function renderPrice(el, str) {
    if (!el) return;
    str = String(str || '');
    if (el.getAttribute('data-p') === str) return;
    el.setAttribute('data-p', str);
    el.textContent = '';
    var m = PRICE_RE.exec(str.trim());
    if (m) {
      el.appendChild(document.createTextNode(m[1] + m[2] + '.'));
      var sup = document.createElement('span');
      sup.className = 'pdp-pence';
      sup.textContent = m[3];
      el.appendChild(sup);
      if (m[4]) el.appendChild(document.createTextNode(m[4]));
    } else {
      el.textContent = str;
    }
  }
  function every(b) { return b === 1 ? 'every month' : 'every ' + b + ' months'; }

  function init(root) {
    if (root.__pdpReady) return;
    root.__pdpReady = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var d = root.dataset;
    var $ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var one = function (sel) { return root.querySelector(sel); };
    var timers = {};
    var cleanups = [];
    function on(target, type, fn, opts) { target.addEventListener(type, fn, opts); cleanups.push(function () { target.removeEventListener(type, fn, opts); }); }

    /* ---------------- tier data ---------------- */
    var tiers = [];
    try { tiers = JSON.parse((one('[data-pdp-tiers]') || {}).textContent || '[]'); }
    catch (e) { if (window.console) console.error('[nc-pdp] tier data could not be parsed', e); }
    tiers.forEach(function (t) {
      t.bottles = t.bottles || 1;
      t.days = t.days || t.bottles * 30;
      // typed preview prices (theme editor, unbound tier) until a variant binds
      if (!t.cOne) t.cOne = toCents(t.priceOne);
      if (!t.cSub) t.cSub = toCents(t.priceSub);
      if (!t.cRrp) t.cRrp = toCents(t.rrp);
    });
    var byN = {};
    tiers.forEach(function (t) { byN[t.n] = t; });
    var single = tiers.filter(function (t) { return t.bottles === 1; })[0]; // the per-bottle reference for "Save £x vs single bottles"

    var st = { tier: parseInt(d.defaultTier, 10) || 1, mode: 'one', sheet: false, accOpen: -1, dpPhase: reduce ? 2 : 0, nowTick: Date.now() };
    if (!byN[st.tier]) st.tier = tiers.length ? tiers[0].n : 1;
    var soldOut = false, busy = false, ctaState = 'idle';
    var perDay = d.perDay || '';

    function cur() { return byN[st.tier]; }
    function subOn(t) { return st.mode === 'sub' && !!(t && t.plan && t.cSub); }
    function centsOf(t) { return subOn(t) ? t.cSub : t.cOne; }
    function buyable(t) { return !!(t && t.vOne && t.avail && !soldOut); }
    function showRrp() { return d.showRrp === 'true'; }
    function saveText(t) {
      var c = centsOf(t), parts = [];
      if (subOn(t)) parts.push('Save ' + money(t.cOne - t.cSub) + ' every delivery');
      else if (single && t !== single && single.cOne * t.bottles > t.cOne) parts.push('Save ' + money(single.cOne * t.bottles - t.cOne) + ' vs single bottles');
      if (perDay && c && t.days) parts.push(money(Math.round(c / t.days)) + ' ' + perDay);
      return parts.join(' · ');
    }

    /* ---------------- render: every surface follows the selected tier + mode ---------------- */
    function setCtaLabels() {
      var t = cur();
      $('[data-add]').forEach(function (b) {
        if (ctaState !== 'idle') return;
        b.classList.remove('is-loading', 'is-added', 'is-error');
        var lbl = b.querySelector('[data-cta-label]');
        var ok = buyable(t);
        b.disabled = !ok;
        if (!lbl) return;
        if (ok) {
          if (!lbl.querySelector('[data-cta-price]')) {
            lbl.textContent = 'Add to basket | ';
            var sp = document.createElement('span');
            sp.className = 'pdp-price';
            sp.setAttribute('data-cta-price', '');
            lbl.appendChild(sp);
          }
          renderPrice(lbl.querySelector('[data-cta-price]'), money(centsOf(t)));
        } else {
          lbl.textContent = (soldOut || (t && t.vOne && !t.avail)) ? 'Sold out' : 'Unavailable';
        }
      });
      var barCta = one('[data-bar-cta]');
      if (barCta) barCta.disabled = soldOut;
    }

    function render(animate) {
      var t = cur();
      if (!t) return;
      if (st.mode === 'sub' && !t.plan) st.mode = 'one';
      var sub = subOn(t);
      root.classList.toggle('is-sub', sub);

      // course cards + sheet rows (radio groups)
      $('[data-tier]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-tier'), 10);
        var tt = byN[n];
        var sel = n === st.tier;
        el.classList.toggle('is-sel', sel);
        el.setAttribute('aria-checked', sel ? 'true' : 'false');
        el.setAttribute('tabindex', sel ? '0' : '-1');
        if (!tt) return;
        el.classList.toggle('is-off', !!(tt.vOne && !tt.avail));
        var c = centsOf(tt);
        renderPrice(el.querySelector('[data-price]'), money(c));
        var rr = el.querySelector('[data-rrp]');
        if (rr) {
          // subscription: struck one-off price (a genuine, current price). One-off: RRP only when the setting allows it.
          var was = subOn(tt) ? tt.cOne : (showRrp() && tt.cRrp > tt.cOne ? tt.cRrp : 0);
          rr.textContent = was ? money(was) : '';
          rr.hidden = !was;
        }
        var un = el.querySelector('[data-unit]');
        if (un) un.textContent = money(Math.round(c / tt.bottles)) + ' a bottle';
        var sv = el.querySelector('[data-save]');
        if (sv) sv.textContent = (tt.vOne && !tt.avail) ? 'Sold out' : saveText(tt);
      });
      if (animate && !reduce) {
        var selEl = one('.pdp-opt.is-sel');
        if (selEl) { selEl.classList.remove('is-swap'); void selEl.offsetWidth; selEl.classList.add('is-swap'); }
      }

      // one-off / subscribe rows
      $('[data-plan]').forEach(function (r) {
        var isSub = r.getAttribute('data-plan') === 'sub';
        var selR = isSub === sub;
        r.classList.toggle('is-sel', selR);
        r.setAttribute('aria-checked', selR ? 'true' : 'false');
        r.setAttribute('tabindex', selR ? '0' : '-1');
        if (isSub) { r.classList.toggle('is-na', !t.plan); r.setAttribute('aria-disabled', t.plan ? 'false' : 'true'); }
      });
      $('[data-plan-price="one"]').forEach(function (p) { renderPrice(p, money(t.cOne)); });
      $('[data-plan-price="sub"]').forEach(function (p) { renderPrice(p, t.cSub ? money(t.cSub) : ''); });
      $('[data-plan-chip]').forEach(function (ch) { ch.textContent = t.cSub ? 'Save ' + money(t.cOne - t.cSub) : ''; ch.hidden = !t.cSub; });
      $('[data-plan-every]').forEach(function (e) { e.textContent = 'Delivered ' + every(t.bottles) + ' · cancel any time'; });
      var terms = one('[data-sub-terms]');
      if (terms && t.cSub) {
        var who = t.bottles === 1 ? 'Your next bottle arrives in a month' : 'Your next ' + t.bottles + ' bottles arrive in ' + t.bottles + ' months';
        terms.textContent = who + ' at ' + money(t.cSub) + '. We email you before every delivery. Skip, pause or cancel online in two clicks.';
      }

      // sticky bar
      var thumb = one('[data-bar-thumb]');
      if (thumb && t.thumb && thumb.getAttribute('src') !== t.thumb) thumb.setAttribute('src', t.thumb);
      var bn = one('[data-bar-name]'); if (bn) bn.textContent = t.name + (sub ? ' · subscription' : '');
      renderPrice(one('[data-bar-now]'), money(centsOf(t)));
      var was = one('[data-bar-was]');
      if (was) { var w = sub ? t.cOne : (showRrp() && t.cRrp > t.cOne ? t.cRrp : 0); was.textContent = w ? money(w) : ''; was.hidden = !w; }

      setCtaLabels();
    }

    function pick(n, focus) {
      if (!byN[n]) return;
      var changed = n !== st.tier;
      st.tier = n;
      render(changed);
      if (focus) {
        var grp = focus.closest('[data-group]');
        var el = grp && grp.querySelector('[data-tier="' + n + '"]');
        if (el) el.focus();
      }
    }
    $('[data-tier]').forEach(function (el) {
      on(el, 'click', function () { pick(parseInt(el.getAttribute('data-tier'), 10)); });
      on(el, 'keydown', function (e) {
        var n = parseInt(el.getAttribute('data-tier'), 10);
        var idx = tiers.indexOf(byN[n]);
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); pick(n); return; }
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step || !tiers.length) return;
        e.preventDefault();
        pick(tiers[(idx + step + tiers.length) % tiers.length].n, el);
      });
    });
    function setMode(m, focusEl) {
      var t = cur();
      if (m === 'sub' && !(t && t.plan)) return;
      st.mode = m;
      render(false);
      if (focusEl) { var g = focusEl.closest('[data-plans]'); var r = g && g.querySelector('[data-plan="' + m + '"]'); if (r) r.focus(); }
    }
    $('[data-plan]').forEach(function (r) {
      on(r, 'click', function () { setMode(r.getAttribute('data-plan')); });
      on(r, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); setMode(r.getAttribute('data-plan')); return; }
        if (/^Arrow/.test(e.key)) { e.preventDefault(); setMode(r.getAttribute('data-plan') === 'sub' ? 'one' : 'sub', r); }
      });
    });

    /* ---------------- gallery (v1.5) ---------------- */
    var stage = one('[data-stage]');
    var thumbs = $('[data-thumb]');
    var prevBtn = one('[data-prev]');
    var nextBtn = one('[data-next]');
    var slideCount = stage ? stage.querySelectorAll('[data-slide]').length : 0;
    var gi = 0;
    function keepInView(el) {
      var strip = el && el.parentNode;
      if (!strip) return;
      var sr = strip.getBoundingClientRect(), r = el.getBoundingClientRect();
      if (r.left < sr.left) strip.scrollLeft += r.left - sr.left - 8;
      else if (r.right > sr.right) strip.scrollLeft += r.right - sr.right + 8;
      if (r.top < sr.top) strip.scrollTop += r.top - sr.top - 4;
      else if (r.bottom > sr.bottom) strip.scrollTop += r.bottom - sr.bottom + 4;
    }
    function setActive(i) {
      gi = i;
      thumbs.forEach(function (th, j) {
        var a = j === i;
        th.classList.toggle('is-active', a);
        if (a) th.setAttribute('aria-current', 'true'); else th.removeAttribute('aria-current');
      });
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= slideCount - 1;
      keepInView(thumbs[i]);
    }
    function goTo(i, smooth) {
      if (!stage || !slideCount) return;
      i = Math.max(0, Math.min(slideCount - 1, i));
      stage.scrollTo({ left: i * stage.clientWidth, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
      setActive(i);
    }
    if (stage && slideCount) {
      var sRaf = 0;
      on(stage, 'scroll', function () {
        if (sRaf) return;
        sRaf = requestAnimationFrame(function () {
          sRaf = 0;
          var w = stage.clientWidth || 1;
          var i = Math.round(stage.scrollLeft / w);
          if (i !== gi && i >= 0 && i < slideCount) setActive(i);
        });
      }, { passive: true });
      thumbs.forEach(function (th) { on(th, 'click', function () { goTo(parseInt(th.getAttribute('data-thumb'), 10) || 0, true); }); });
      if (prevBtn) on(prevBtn, 'click', function () { goTo(gi - 1, true); });
      if (nextBtn) on(nextBtn, 'click', function () { goTo(gi + 1, true); });
      on(stage, 'keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1, true); }
      });
      setActive(0);
    }

    /* ---------------- sticky left column (v1.5) ---------------- */
    var left = one('[data-left]');
    function stick() {
      if (!left) return;
      var top = Math.min(24, window.innerHeight - left.offsetHeight - 24);
      left.style.setProperty('--stick', top + 'px');
    }
    var rsRaf = 0;
    on(window, 'resize', function () {
      if (rsRaf) return;
      rsRaf = requestAnimationFrame(function () { rsRaf = 0; stick(); if (stage && slideCount) goTo(gi, false); });
    }, { passive: true });
    if (left && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(stick);
      ro.observe(left);
      cleanups.push(function () { ro.disconnect(); });
    }
    stick();

    /* ---------------- accordions (v1.5) ---------------- */
    $('.pdp-acc').forEach(function (acc, i) {
      var head = acc.querySelector('.pdp-acc-head');
      if (!head) return;
      on(head, 'click', function () {
        var willOpen = st.accOpen !== i;
        $('.pdp-acc').forEach(function (a, j) {
          var openNow = j === i && willOpen;
          a.classList.toggle('is-open', openNow);
          var h = a.querySelector('.pdp-acc-head');
          if (h) h.setAttribute('aria-expanded', openNow ? 'true' : 'false');
        });
        st.accOpen = willOpen ? i : -1;
      });
    });

    /* ---------------- nutrition label pop-up (v1.5) ---------------- */
    var labelDlg = one('[data-label-dialog]');
    var labelBtn = one('[data-label-open]');
    if (labelDlg && labelBtn && typeof labelDlg.showModal === 'function') {
      on(labelBtn, 'click', function () { labelDlg.showModal(); document.documentElement.style.overflow = 'hidden'; });
      on(labelDlg, 'close', function () { document.documentElement.style.overflow = ''; });
      $('[data-label-close]').forEach(function (b) { on(b, 'click', function () { labelDlg.close(); }); });
      on(labelDlg, 'click', function (e) { if (e.target === labelDlg) labelDlg.close(); });
    }

    /* ---------------- sticky bar + plan sheet (v1.5) ---------------- */
    var bar = one('[data-bar]');
    var mainCta = one('.pdp-buy [data-add]');
    if (bar) {
      if (d.barBehavior === 'always' || !mainCta) {
        bar.classList.add('is-on');
      } else {
        var bRaf = 0;
        var updateBar = function () { bRaf = 0; bar.classList.toggle('is-on', mainCta.getBoundingClientRect().bottom < 0); };
        on(window, 'scroll', function () { if (!bRaf) bRaf = requestAnimationFrame(updateBar); }, { passive: true });
        updateBar();
      }
    }
    var sheet = one('[data-sheet]');
    var sheetBack = one('.pdp-sheet-back');
    var lastFocus = null;
    function openSheet(open) {
      if (!sheet) return;
      st.sheet = open;
      sheet.hidden = !open;
      if (sheetBack) sheetBack.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocus = document.activeElement;
        var f = sheet.querySelector('.pdp-row.is-sel') || sheet.querySelector('button');
        if (f) f.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
        lastFocus = null;
      }
    }
    var barCta = one('[data-bar-cta]');
    if (barCta) on(barCta, 'click', function () { if (!soldOut) openSheet(true); });
    $('[data-sheet-close]').forEach(function (b) { on(b, 'click', function () { openSheet(false); }); });
    on(document, 'keydown', function (e) {
      if (!st.sheet) return;
      if (e.key === 'Escape') { openSheet(false); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(sheet.querySelectorAll('button:not([disabled]), [tabindex="0"]'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------------- cart (v1.5 = nc-buy v3.10 path, unchanged) ---------------- */
    function setCta(state, text) {
      ctaState = state;
      $('[data-add]').forEach(function (b) {
        b.classList.toggle('is-loading', state === 'loading');
        b.classList.toggle('is-added', state === 'added');
        b.classList.toggle('is-error', state === 'error');
        b.disabled = state === 'loading';
        var lbl = b.querySelector('[data-cta-label]');
        if (lbl && text) lbl.textContent = text;
      });
      if (state === 'idle') setCtaLabels();
    }
    function writeCount(n) {
      ['[data-cart-count]', '.cart-count-bubble span[aria-hidden]', '.cart-count-bubble span', '.cart-count',
        '.cart-item-count', '#CartCount', '.header__cart-count', '.js-cart-count'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.children.length === 0 && /^\s*\d*\s*$/.test(el.textContent)) {
            el.textContent = n;
            [el, el.parentElement].forEach(function (x) {
              if (!x) return;
              if (x.hasAttribute('hidden')) x.removeAttribute('hidden');
              if (x.style && x.style.display === 'none') x.style.display = '';
              x.classList.remove('hidden', 'is-empty', 'is-hidden');
            });
          }
        });
      });
    }
    function refreshCount() {
      fetch(routeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && typeof c.item_count === 'number') writeCount(c.item_count); })
        .catch(function () {});
    }
    function openDrawer(data, attempt) {
      attempt = attempt || 0;
      var dr = document.querySelector('cart-drawer');
      if (dr && typeof dr.open !== 'function' && attempt < 10) { timers.drawer = setTimeout(function () { openDrawer(data, attempt + 1); }, 100); return; }
      var html = data && data.sections && data.sections['cart-drawer'];
      if (dr && html) {
        try {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
          var live = document.querySelector('#CartDrawer');
          if (fresh && live) {
            live.innerHTML = fresh.innerHTML;
            dr.classList.toggle('is-empty', (data && typeof data.item_count === 'number') ? data.item_count === 0 : false);
            var ov = dr.querySelector('#CartDrawer-Overlay');
            if (ov && typeof dr.close === 'function') ov.addEventListener('click', dr.close.bind(dr));
            if (typeof dr.open === 'function') dr.open();
            else { dr.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
            root.setAttribute('data-nc-drawer', 'swap+open');
            refreshCount();
            return;
          }
        } catch (err) { if (window.console) console.warn('[nc-pdp] drawer swap failed, falling through', err); }
      }
      if (dr && typeof dr.open === 'function') { dr.open(); root.setAttribute('data-nc-drawer', 'open (no section render)'); refreshCount(); return; }
      var legacy = window.NutricalsCart;
      if (legacy && typeof legacy.reRenderAndOpen === 'function') { legacy.reRenderAndOpen(); root.setAttribute('data-nc-drawer', 'NutricalsCart'); return; }
      root.setAttribute('data-nc-drawer', 'cart page');
      window.location.href = routeRoot() + 'cart';
    }
    function addToCart() {
      if (busy) return;
      var t = cur();
      if (!buyable(t)) { if (window.console && t && !t.vOne) console.error('[nc-pdp] tier ' + t.n + ' has no variant bound.'); return; }
      var sub = subOn(t);
      var body = { id: parseInt(sub ? (t.vSub || t.vOne) : t.vOne, 10), quantity: 1 };
      if (sub) body.selling_plan = parseInt(t.plan, 10);
      if (document.querySelector('cart-drawer')) { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
      busy = true;
      setCta('loading', 'Adding…');
      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ('cart ' + r.status)); return j; }); })
        .then(function (data) {
          setCta('added', 'Added to basket');
          if (st.sheet) openSheet(false);
          document.dispatchEvent(new CustomEvent('nc:cart:added', { detail: { tier: t.n, variant: body.id, sellingPlan: body.selling_plan || null } }));
          openDrawer(data);
          timers.reset = setTimeout(function () { busy = false; setCta('idle'); }, 1400);
        })
        .catch(function (err) {
          if (window.console) console.error('[nc-pdp] cart add failed', err);
          setCta('error', 'Could not add — try again');
          timers.reset = setTimeout(function () { busy = false; setCta('idle'); }, 2200);
        });
    }
    $('[data-add]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); addToCart(); }); });

    /* ---------------- rescue: bind unbound tiers from the storefront product JSON (v1.5 logic, v1.6 fields) ---------------- */
    function rescue() {
      if (d.binding === 'manual') return;
      var unbound = tiers.filter(function (t) { return !t.vOne; });
      if (!unbound.length) return;
      var url = d.handle ? routeRoot() + 'products/' + d.handle + '.js' : null;
      if (window.console) console.warn('[nc-pdp] ' + unbound.length + ' tier(s) reached the browser unbound. ' + (url ? 'Trying ' + url : 'No product handle; set "Select product".'));
      if (!url) return;
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          unbound.forEach(function (t) {
            var v = vs.filter(function (x) { return parseInt(x.title, 10) === t.bottles; })[0] || vs[t.bottles - 1];
            if (!v) return; // never fall back to another variant: wrong quantity at the wrong price
            t.vOne = v.id; t.avail = v.available !== false; t.bound = 'rescue'; t.cOne = v.price;
            if (v.compare_at_price && v.compare_at_price > v.price) t.cRrp = v.compare_at_price;
            var a = v.selling_plan_allocations && v.selling_plan_allocations[0];
            if (a) { t.plan = a.selling_plan_id; t.vSub = v.id; if (a.price) t.cSub = a.price; }
          });
          render(false);
        })
        .catch(function (e) { if (window.console) console.error('[nc-pdp] rescue failed', e); });
    }

    /* ---------------- dispatch panel (v1.5, unchanged) ---------------- */
    var cfg = {
      cutoffHour: parseInt(d.cutoffHour, 10) || 20,
      dispatchDays: (d.dispatchDays || '0123456').split('').map(Number),
      liveWithin: 8, nextBatchEta: d.nextBatchEta || '', lowStock: parseInt(d.lowStock, 10) || 25,
      inventory: (d.inventory === '' || d.inventory == null) ? null : parseInt(d.inventory, 10),
      panelState: d.panelState || 'auto', timeScenario: d.timeScenario || 'auto'
    };
    function iso(dt) { return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate(); }
    function isDispatch(dt) { return cfg.dispatchDays.indexOf(dt.getDay()) !== -1; }
    function fmtDate(dt) { return DS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MS[dt.getMonth()]; }
    function fmtHour(h) { return (h % 12 === 0 ? 12 : h % 12) + (h >= 12 ? 'pm' : 'am'); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function nextDispatchFrom(dt, inclToday) {
      var x = new Date(dt);
      if (!inclToday) x.setDate(x.getDate() + 1);
      for (var i = 0; i < 21; i++) { if (isDispatch(x)) return x; x.setDate(x.getDate() + 1); }
      return x;
    }
    function londonNow(ms) {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }).formatToParts(new Date(ms));
        var o = {};
        parts.forEach(function (x) { o[x.type] = x.value; });
        return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
      } catch (e) { return new Date(ms); }
    }
    function computeDispatch() {
      var now = londonNow(st.nowTick);
      var stock = 'in-stock';
      if (cfg.inventory != null && !isNaN(cfg.inventory)) stock = cfg.inventory <= 0 ? 'sold-out' : (cfg.inventory <= cfg.lowStock ? 'low-stock' : 'in-stock');
      var ps = cfg.panelState;
      if (ps === 'in-stock' || ps === 'low-stock' || ps === 'sold-out') stock = ps;
      var checking = ps === 'checking' || (ps === 'auto' && st.dpPhase < 2);
      var cut = new Date(now); cut.setHours(cfg.cutoffHour, 0, 0, 0);
      var shipsToday = isDispatch(now) && now < cut;
      var live = false, dispatchDate, pre, em, post;
      if (shipsToday) {
        dispatchDate = new Date(now);
        var msLeft = cut - now;
        if (msLeft / 3600000 > cfg.liveWithin) { pre = 'Order by '; em = fmtHour(cfg.cutoffHour); post = ' today for same-day dispatch.'; }
        else { live = true; var s = Math.floor(msLeft / 1000); pre = 'Order within '; em = Math.floor(s / 3600) + 'h ' + pad(Math.floor(s % 3600 / 60)) + 'm ' + pad(s % 60) + 's'; post = ' — ships today.'; }
      } else {
        dispatchDate = nextDispatchFrom(now, false);
        var tom = new Date(now); tom.setDate(tom.getDate() + 1);
        var isTom = iso(dispatchDate) === iso(tom);
        pre = 'Order now — ships '; em = isTom ? 'first thing tomorrow' : DW[dispatchDate.getDay()] + ' morning'; post = '.';
      }
      return {
        checking: checking, stock: stock, soldOut: stock === 'sold-out' && !checking, live: live && cfg.timeScenario === 'auto',
        pre: pre, em: em, post: post,
        sub1: shipsToday ? 'by ' + fmtHour(cfg.cutoffHour) : 'now',
        sub2: shipsToday ? 'today' : (em === 'first thing tomorrow' ? 'tomorrow' : DW[dispatchDate.getDay()]),
        sub3: 'est. ' + fmtDate(new Date(now.getTime() + 172800000)),
        batch: stock === 'low-stock' ? 'This batch is nearly gone. The next lands ' + cfg.nextBatchEta + ' — order today and yours ships from the current run.'
          : stock === 'sold-out' ? 'This batch sold out. The next lands ' + cfg.nextBatchEta + '.' : ''
      };
    }
    function paintDispatch() {
      var dp = computeDispatch();
      var wasSold = soldOut;
      soldOut = dp.soldOut;
      root.classList.toggle('dp-checking', dp.checking);
      root.classList.toggle('dp-soldout', dp.soldOut);
      root.setAttribute('data-stock', dp.stock);
      var set = function (sel, v) { var e = one(sel); if (e && e.textContent !== v) e.textContent = v; };
      set('[data-dp-pre]', dp.soldOut ? 'Sold out — ' : dp.pre);
      set('[data-dp-em]', dp.soldOut ? 'back soon' : dp.em);
      set('[data-dp-post]', dp.soldOut ? '.' : dp.post);
      set('[data-dp-sub1]', dp.sub1);
      set('[data-dp-sub2]', dp.sub2);
      set('[data-dp-sub3]', dp.sub3);
      var batch = one('[data-dp-batch]');
      if (batch) { batch.textContent = dp.batch; batch.hidden = !dp.batch; }
      if (wasSold !== soldOut) setCtaLabels();
      return dp;
    }
    function tick() {
      st.nowTick = Date.now();
      var dp = paintDispatch();
      timers.tick = setTimeout(tick, dp.live ? 1000 - (Date.now() % 1000) : 30000);
    }
    if (!reduce && cfg.panelState === 'auto') {
      timers.dp1 = setTimeout(function () { st.dpPhase = 1; paintDispatch(); }, 450);
      timers.dp2 = setTimeout(function () { st.dpPhase = 2; paintDispatch(); }, 900);
    } else { st.dpPhase = 2; }

    /* ---------------- start ---------------- */
    render(false);
    tick();
    rescue();

    window.ncPdp = {
      version: '1.6',
      root: root,
      tiers: tiers,
      render: function () { render(false); },
      status: function () {
        return {
          selected: st.tier, mode: st.mode, soldOut: soldOut,
          tiers: tiers.map(function (t) { return { tier: t.n, bottles: t.bottles, variant: t.vOne, plan: t.plan || '', bound: t.bound, available: t.avail, one: money(t.cOne), sub: t.cSub ? money(t.cSub) : '' }; }),
          lastOpenedVia: root.getAttribute('data-nc-drawer') || '(nothing added yet)'
        };
      }
    };
    root.__pdpTeardown = function () {
      Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); });
      if (labelDlg && labelDlg.open) labelDlg.close();
      cleanups.forEach(function (fn) { fn(); });
      document.documentElement.style.overflow = '';
      root.__pdpReady = false;
    };
  }

  function boot() { document.querySelectorAll('[data-nc-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector ? e.target.querySelector('[data-nc-pdp]') : null; if (el) init(el); });
  document.addEventListener('shopify:section:unload', function (e) { var el = e.target.querySelector ? e.target.querySelector('[data-nc-pdp]') : null; if (el && typeof el.__pdpTeardown === 'function') el.__pdpTeardown(); });
})();
